var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTinyLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 69,
    viewBox: "0 0 70 69",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.8164 5.66958H31.5842L33.2019 2.83479L34.8197 0L36.4341 2.83479L38.0519 5.66958H34.8197H34.8164ZM31.5842 63.3304L33.1986 66.1652L34.8164 69L36.4308 66.1652L38.0486 63.3304H31.5842ZM70 34.3526L67.2012 32.714L64.4024 31.0788V37.6263L67.2012 35.9878L70 34.3526ZM60.5912 34.3325C60.5912 49.8836 50.3554 60.2544 34.9983 60.2544C19.6413 60.2544 9.40545 49.8836 9.40545 34.3325C9.40545 18.7813 19.6446 8.41055 34.9983 8.41055C50.3521 8.41055 60.5912 18.778 60.5912 34.3325ZM48.5193 34.3325C48.5193 25.5299 43.1103 19.6592 34.9983 19.6592C26.8864 19.6592 21.4807 25.5299 21.4807 34.3325C21.4807 43.1351 26.8897 49.0057 34.9983 49.0057C43.1069 49.0057 48.5193 43.1384 48.5193 34.3325ZM0 34.3526L2.79881 35.9878L5.59762 37.6263V34.3526V31.0788L2.79881 32.714L0 34.3526Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTinyLogo);
export default __webpack_public_path__ + "static/media/tinyLogo.b222b84a3ce2c7bd1c5a106782ee9920.svg";
export { ForwardRef as ReactComponent };